export enum ChannelType {
	Consultation = 1,
	TherapyGroup = 2,
	General = 3,
}
